import "./App.css";

function Header() {
  return (
    <>
      <div className="header">
        <h5 id="headerheading">कुम्हार समाज सेवा संस्थान, झुंझुनूं</h5>
      </div>
    </>
  );
}

export default Header;
